import { render, staticRenderFns } from "./CourseChapterEdit.vue?vue&type=template&id=e3badaac&scoped=true&"
import script from "./CourseChapterEdit.vue?vue&type=script&lang=js&"
export * from "./CourseChapterEdit.vue?vue&type=script&lang=js&"
import style0 from "./CourseChapterEdit.vue?vue&type=style&index=0&id=e3badaac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3badaac",
  null
  
)

export default component.exports